<template>
  <div class="px-3">
    <div id="menu">
      <div class="sticky-top bg-white">
        <nav class="small">
          <ol class="breadcrumb pb-0">
            <li class="breadcrumb-item">
              <a @click="$emit('close')">Menu</a>
            </li>
            <li class="breadcrumb-item">
              <a @click="$emit('back')">Components</a>
            </li>
            <li class="breadcrumb-item active">{{ rootComponent.componentId.tagName }}</li>
          </ol>
        </nav>
        <div class="d-flex justify-content-start mx-n3 p-2 border-bottom mb-3">
          <a @click="$emit('back')">
            <i class="far fa-chevron-left fa-1x fa-fw"></i>
          </a>
          <h5 class="m-0 p-0">{{ rootComponent.componentId.tagName }}</h5>
        </div>
      </div>
    </div>
    <div class="card mb-4">
      <h5 class="card-header">Linked {{ `${linkType[0].toUpperCase()}${linkType.slice(1)}` }} Components</h5>
      <div class="list-group list-group-flush" v-if="linkedComponents.length">
        <draggable v-model="linkedComponents">
          <div
            v-for="cmp in linkedComponents"
            :key="cmp._id"
            class="list-group-item d-flex justify-content-between align-items-center cursor-move align-items-center"
          >
            <div class="d-flex">
              <div><i class="far fa-bars mr-2"></i></div>
              <div>
                <a>{{ cmp.componentId.tagName }}</a>
                <div class="small">
                  {{ cmp.description }}
                </div>
              </div>
            </div>

            <div>
              <a><i @click="removeComponent(cmp._id)" class="far fa-trash text-primary float-right"></i></a>
            </div>
          </div>
        </draggable>
      </div>
      <div class="card-body" v-else>None assigned</div>
    </div>
    <top-table
      ref="table"
      class="table-sm"
      method="post"
      :requestFunction="requestFunction"
      :keepInGlobalStore="false"
      :tabFilterClass="['col-6 pb-2 pt-2']"
      :url="`/store/components/by-store/${storeId}`"
      :tab-filters="[{ val: 'isGlobal', criteria: ['Yes', 'No'], selected: ['Yes'] }]"
      :columns="['componentId.tagName', 'description', 'toAdd']"
      :sortable="['description']"
      :headings="{
        'componentId.tagName': 'Name',
        description: 'Description',
        toAdd: 'Add'
      }"
      :overlap="true"
    >
      <div class="nav-link" slot="componentId.tagName" slot-scope="props">
        <span>{{ props.row.componentId.tagName }}</span>
      </div>
      <a slot="toAdd" slot-scope="props" @click="addComponent(props.row)"
        ><button type="button" class="btn btn-primary">Link</button></a
      >
    </top-table>
    <button type="button" @click="$emit('linkComponent', linkedComponents)" class="btn btn-primary" :disabled="loading">
      <i class="far fa-spinner-third fa-spin mr-2" v-if="loading"></i>
      Save Changes
    </button>
    <button type="button" @click.prevent="$emit('back')" class="btn btn-link">Cancel</button>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable
  },
  data() {
    return {
      columns: ['componentId.tagName', 'description', 'toAdd'],
      afterLinkedComponents: [],
      beforeLinkedComponents: [],
      options: {
        headings: { toAdd: 'Action', 'componentId.tagName': 'Name', description: 'Description' }
      }
    };
  },
  props: {
    storeId: {
      type: String,
      required: true
    },
    linkType: {
      type: String,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    rootComponent: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.afterLinkedComponents = [...this.rootComponent.afterLinkedComponents] || [];
    this.beforeLinkedComponents = [...this.rootComponent.beforeLinkedComponents] || [];
  },
  beforeDestroy() {
    this.afterLinkedComponents = [];
    this.beforeLinkedComponents = [];
  },
  computed: {
    linkedComponents: {
      get() {
        return this[`${this.linkType}LinkedComponents`];
      },
      set(list) {
        this[`${this.linkType}LinkedComponents`] = list;
      }
    }
  },
  methods: {
    requestFunction(params) {
      params.notIn = [...this[`${this.linkType}LinkedComponents`].map((i) => i._id), this.rootComponent._id];
      params.withoutLinked = `${this.linkType}LinkedComponents`;
      params.model = this.model;
      params.columns = ['description'];
    },
    addComponent(component) {
      if (this.linkType === 'after') this.afterLinkedComponents.push(component);
      else this.beforeLinkedComponents.unshift(component);
    },
    removeComponent(componentId) {
      const index = this[`${this.linkType}LinkedComponents`].findIndex((c) => c._id === componentId);
      this[`${this.linkType}LinkedComponents`].splice(index, 1);
    }
  }
};
</script>
